export default "__VITE_ASSET__mU8ZMlUz__"